var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.fieldClass
  }, [_vm.hasLabel ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.getEditorConfig,
      "tag-name": "textarea",
      "name": _vm.fieldName,
      "id": _vm.id
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }